import {getInstructorQuery} from './get-instructor'

export const InstructorService = {
  getInstructorQuery,
}
